
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/how-it-works/free-groom-rental",
      function () {
        return require("private-next-pages/how-it-works/free-groom-rental.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/how-it-works/free-groom-rental"])
      });
    }
  